document.addEventListener('DOMContentLoaded',()=>{const toggle=document.querySelector('.mobile-menu-toggle'),nav=document.getElementById('mobile-nav');if(toggle&&nav){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close menu':'Open menu');nav.hidden=!open;});}document.querySelectorAll('[data-carousel]').forEach(rail=>{const area=rail.closest('section');area.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth*.75,behavior:'smooth'}));area.querySelector('[data-carousel-next]')?.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth*.75,behavior:'smooth'}));});document.querySelectorAll('.gallery-thumb').forEach(button=>button.addEventListener('click',()=>{const image=document.getElementById('main-product-image');if(image){image.src=button.dataset.image;image.removeAttribute('srcset');}}));});
// Shopify collection filtering uses collection URLs rather than client-side hiding.
// This preserves correct pagination, inventory, and collection membership.
document.addEventListener('change',function(event){
  const selector=event.target.closest('[data-collection-filter]');
  if(selector && selector.value && selector.value.startsWith('/collections/')){
    window.location.assign(selector.value);
  }
});

// Accessible cart quantity steppers; updates are submitted through Shopify's native cart form.
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-qty-minus], [data-qty-plus]');
  if (!button) return;
  const controls = button.closest('.cart-qty-controls');
  const input = controls && controls.querySelector('input[type="number"]');
  if (!input) return;
  const min = Number(input.min || 0), max = input.max ? Number(input.max) : Infinity;
  const next = Number(input.value || 0) + (button.hasAttribute('data-qty-plus') ? 1 : -1);
  input.value = String(Math.max(min, Math.min(max, next)));
});

/* TriForge events calendar: date-only parsing avoids timezone drift. */
(function(){
  function init(root){
    if(root.dataset.initialized) return; root.dataset.initialized='true';
    const node=root.querySelector('[data-event-json]');
    let entries=[];try{entries=JSON.parse(node.textContent||'[]')}catch(e){console.warn('Invalid TriForge event data',e)}
    const valid=/^\d{4}-\d{2}-\d{2}$/;
    const parse=s=>{if(!valid.test(s||''))return null;const [y,m,d]=s.split('-').map(Number),v=new Date(y,m-1,d);return v.getFullYear()===y&&v.getMonth()===m-1&&v.getDate()===d?v:null};
    const dateKey=d=>`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    entries=entries.filter(e=>parse(e.date)).map(e=>({...e,end:parse(e.endDate)||parse(e.date)}));
    const grid=root.querySelector('[data-calendar-grid]'),heading=root.querySelector('[data-month-heading]'),upcoming=root.querySelector('[data-upcoming-list]');
    let cursor=new Date();cursor.setDate(1);
    const today=new Date();today.setHours(0,0,0,0);
    const fmt=new Intl.DateTimeFormat(undefined,{month:'long',year:'numeric'});
    const nice=d=>new Intl.DateTimeFormat(undefined,{month:'short',day:'numeric',year:'numeric'}).format(d);
    function safeLink(e){
      if(typeof e.url!=='string'||!e.url.startsWith('/')&&!/^https:\/\//i.test(e.url))return null;
      return e.url;
    }
    function chip(e){const a=document.createElement(safeLink(e)?'a':'span');a.className='tf-cal-chip';a.textContent=e.title;if(safeLink(e))a.href=safeLink(e);else a.title='Details page coming soon';return a}
    function render(){
      grid.replaceChildren();heading.textContent=fmt.format(cursor);
      const year=cursor.getFullYear(),month=cursor.getMonth(),first=new Date(year,month,1).getDay(),days=new Date(year,month+1,0).getDate();
      const cells=Math.ceil((first+days)/7)*7;
      for(let i=0;i<cells;i++){
        const d=new Date(year,month,i-first+1),inMonth=d.getMonth()===month;
        const cell=document.createElement('div');cell.className='tf-cal-day'+(inMonth?'':' tf-other-month')+(dateKey(d)===dateKey(today)?' tf-is-today':'');
        cell.setAttribute('role','gridcell');cell.setAttribute('aria-label',nice(d));
        const num=document.createElement('span');num.className='tf-day-number';num.textContent=d.getDate();cell.append(num);
        entries.filter(e=>{const start=parse(e.date);return d>=start&&d>=new Date(start.getFullYear(),start.getMonth(),start.getDate())&&d<=e.end}).forEach(e=>cell.append(chip(e)));
        grid.append(cell);
      }
      upcoming.replaceChildren();
      const upcomingEvents=entries.filter(e=>e.end>=today).sort((a,b)=>a.date.localeCompare(b.date));
      if(!upcomingEvents.length){const p=document.createElement('p');p.textContent='No upcoming card shows have been announced yet. Check back soon!';upcoming.append(p);return}
      upcomingEvents.forEach(e=>{
        const article=document.createElement('article');article.className='tf-event-row';
        const date=document.createElement('div');date.className='tf-event-date';date.textContent=nice(parse(e.date))+(e.endDate&&e.endDate!==e.date?' – '+nice(e.end):'');
        const content=document.createElement('div');const h=document.createElement('h3');h.textContent=e.title;content.append(h);
        const info=document.createElement('p');info.textContent=[e.time,e.venue,e.location].filter(Boolean).join(' · ');content.append(info);
        article.append(date,content);
        if(safeLink(e)){const link=document.createElement('a');link.href=safeLink(e);link.textContent='Show details →';link.className='tf-event-link';article.append(link)}
        upcoming.append(article);
      });
    }
    root.querySelector('[data-prev-month]').addEventListener('click',()=>{cursor.setMonth(cursor.getMonth()-1);render()});
    root.querySelector('[data-next-month]').addEventListener('click',()=>{cursor.setMonth(cursor.getMonth()+1);render()});
    root.querySelector('[data-today]').addEventListener('click',()=>{cursor=new Date(today.getFullYear(),today.getMonth(),1);render()});
    render();
  }
  document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-events-calendar]').forEach(init));
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-events-calendar]').forEach(init));
})();


/* Forgefront v8: predictive search with safe DOM rendering and standard search fallback. */
(function(){
 function init(form){if(form.dataset.predictiveReady)return;form.dataset.predictiveReady='1';
 const input=form.querySelector('input[name="q"]'),results=form.querySelector('.tf-predictive-results');if(!input||!results)return;
 let timer,controller;const close=()=>{results.hidden=true;results.replaceChildren();input.setAttribute('aria-expanded','false')};
 function link(text,url){const a=document.createElement('a');a.href=url;a.textContent=text;return a}
 input.addEventListener('input',()=>{clearTimeout(timer);if(controller)controller.abort();const term=input.value.trim();if(term.length<2){close();return}
 timer=setTimeout(async()=>{controller=new AbortController();try{
 const url='/search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=product&resources[limit]=5';
 const response=await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});if(!response.ok)throw Error('Search unavailable');
 const data=await response.json();if(input.value.trim()!==term)return;
 results.replaceChildren();const products=data.resources?.results?.products||[];
 const heading=document.createElement('div');heading.className='tf-search-heading';heading.textContent='Matching products';results.append(heading);
 if(!products.length){const p=document.createElement('p');p.textContent='No matching products';results.append(p)}
 products.forEach(p=>{const a=link(p.title,p.url);a.className='tf-search-hit';if(p.featured_image?.url){const img=document.createElement('img');img.src=p.featured_image.url;img.alt='';img.width=44;img.height=44;img.loading='lazy';a.prepend(img)}results.append(a)});
 const all=link('View all search results →','/search?q='+encodeURIComponent(term)+'&type=product');all.className='tf-search-all';results.append(all);
 results.hidden=false;input.setAttribute('aria-expanded','true');
 }catch(e){if(e.name!=='AbortError')close()}},220)
 });
 input.addEventListener('keydown',e=>{if(e.key==='Escape'){close();input.blur()}if(e.key==='ArrowDown'&&!results.hidden){e.preventDefault();results.querySelector('a')?.focus()}});
 form.addEventListener('focusout',()=>{setTimeout(()=>{if(!form.contains(document.activeElement))close()},120)});
 document.addEventListener('pointerdown',e=>{if(!form.contains(e.target))close()});
 }
 function start(){document.querySelectorAll('[data-predictive-search]').forEach(init)}
 document.addEventListener('DOMContentLoaded',start);document.addEventListener('shopify:section:load',start);
})();
/* Mobile filter visibility and keyboard-friendly close behavior */
(function(){function init(){document.querySelectorAll('[data-filter-toggle]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='1';const panel=document.querySelector('[data-filter-panel]');if(!panel)return;
 const set=open=>{panel.classList.toggle('tf-filters-open',open);button.setAttribute('aria-expanded',String(open));if(open)panel.querySelector('summary, input, button')?.focus();else button.focus()};
 button.addEventListener('click',()=>set(button.getAttribute('aria-expanded')!=='true'));
 panel.querySelector('[data-filter-close]')?.addEventListener('click',()=>set(false));
 panel.addEventListener('keydown',e=>{if(e.key==='Escape'&&panel.classList.contains('tf-filters-open'))set(false)});
 })}document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init)})();
/* Forgefront v8.6: homepage show reads the SAME event blocks as /pages/events.
   No duplicate homepage event entries are required. */
(function(){
  function parseDate(s){
    if(!/^\d{4}-\d{2}-\d{2}$/.test(s||''))return null;
    const [y,m,d]=s.split('-').map(Number),v=new Date(y,m-1,d);
    return v.getFullYear()===y&&v.getMonth()===m-1&&v.getDate()===d?v:null;
  }
  function init(){
    document.querySelectorAll('[data-home-show]').forEach(async root=>{
      if(root.dataset.eventsLoading==='true')return;
      root.dataset.eventsLoading='true';
      const content=root.querySelector('[data-home-show-content]');if(!content)return;
      try{
        const response=await fetch('/pages/events',{credentials:'same-origin'});
        if(!response.ok)throw new Error('Events page unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const node=doc.querySelector('[data-events-calendar] [data-event-json]');
        if(!node)throw new Error('Events calendar template not assigned');
        const shows=JSON.parse(node.textContent||'[]');
        const today=new Date();today.setHours(0,0,0,0);
        const next=shows.filter(e=>{
          const start=parseDate(e.date);if(!start)return false;
          const end=parseDate(e.endDate)||start;
          return end>=today;
        }).sort((x,y)=>x.date.localeCompare(y.date))[0];
        if(!next)return;
        content.replaceChildren();
        const h=document.createElement('h3');h.textContent=next.title||'Upcoming show';content.append(h);
        const start=parseDate(next.date),end=parseDate(next.endDate);
        const nice=d=>d.toLocaleDateString(undefined,{month:'long',day:'numeric',year:'numeric'});
        const p=document.createElement('p');
        p.textContent=nice(start)+(end&&end>start?' – '+nice(end):'')+' • '+[next.time,next.venue,next.location].filter(Boolean).join(' · ');
        content.append(p);
        if(typeof next.url==='string'&&(next.url.startsWith('/')||/^https:\/\//i.test(next.url))){
          const a=document.createElement('a');a.href=next.url;a.className='tf-home-show-link';a.textContent='Show details →';content.append(a);
        }
      }catch(err){console.warn('TriForge homepage event sync:',err)}
      finally{root.dataset.eventsLoading='false'}
    });
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
/* Close mobile menu on Escape and return focus to the toggle. */
document.addEventListener('keydown',e=>{if(e.key!=='Escape')return;const nav=document.getElementById('mobile-nav'),toggle=document.querySelector('.mobile-menu-toggle');if(nav&&!nav.hidden&&toggle){nav.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label','Open menu');toggle.focus()}});

/* Variant-aware sealed inventory display. Never show a made-up count. */
(function(){
  function setup(){
    document.querySelectorAll('[data-tf-sealed-stock]').forEach(function(el){
      if(el.dataset.ready)return;el.dataset.ready='true';
      var data=el.parentElement.querySelector('[data-tf-sealed-variants]');
      var select=el.parentElement.querySelector('#variant-select');
      var qty=el.parentElement.querySelector('#product-quantity');
      if(!data)return;
      var variants;try{variants=JSON.parse(data.textContent)}catch(e){return}
      function update(){
        var selected=select?select.value:null;
        var v=variants.find(function(x){return String(x.id)===String(selected)})||variants[0];
        if(!v)return;
        if(v.inventory_management&&v.inventory_policy==='deny'){
          var n=Math.max(0,Number(v.inventory_quantity)||0);
          el.textContent=n===0?'Sold out':n<=3?'Only '+n+' unit'+(n===1?'':'s')+' left':n+' units available';
          if(qty){if(n>0)qty.max=String(n);else qty.removeAttribute('max');if(Number(qty.value)>n&&n>0)qty.value=String(n)}
        }else{if(!el.textContent.trim() || /^(In stock|Sold out)$/i.test(el.textContent.trim())) el.textContent=v.available?'In stock':'Sold out';if(qty)qty.removeAttribute('max')}
      }
      if(select)select.addEventListener('change',update);
      update();
    });
  }
  document.addEventListener('DOMContentLoaded',setup);
  document.addEventListener('shopify:section:load',setup);
})();


/* v8.4: sticky mobile purchase shortcut only when the product form is offscreen. */
(function(){
 function init(){
   var jump=document.querySelector('[data-tf-buy-jump]');
   var target=document.getElementById('product-quantity');
   if(!jump||!target||jump.dataset.ready)return;
   jump.dataset.ready='true';
   var form=target.closest('form');
   if(!form||!('IntersectionObserver' in window))return;
   var obs=new IntersectionObserver(function(entries){
     jump.classList.toggle('tf-buy-jump-visible',!entries[0].isIntersecting && entries[0].boundingClientRect.top<0);
   },{threshold:0});
   obs.observe(form);
 }
 document.addEventListener('DOMContentLoaded',init);
 document.addEventListener('shopify:section:load',init);
})();
